import { useQuery } from '@tanstack/react-query';

import { useChatMessageStore } from '@/entities/chat';
import { QueryKey } from '@/types/query';
import { ChatViewModel, toChatViewModel } from '../model';
import { robinJrChatClient } from './client';

const defaultSelector = <T>(data: ChatViewModel): T => data as T;

export const useGetChatQuery = <SelectedData = ChatViewModel>(
  chatId: number,
  selector = defaultSelector<SelectedData>,
) => {
  return useQuery({
    queryKey: [QueryKey.useGetChatQuery, chatId],
    queryFn: async (): Promise<ChatViewModel> => {
      const response = await robinJrChatClient.getChat(chatId);

      useChatMessageStore.getState().setRecommendations(chatId, response.data.recommendations);

      return toChatViewModel(response.data);
    },
    select: selector,
  });
};
